
define('inlineSvg!svgs/icon/bookmark', function () {return '<span class="inline-bookmark inline-icon"><svg width="8.6" height="16" viewBox="0 0 8.6 16"><path d="M0 15.7V1l1-1h6.5l1 1v14.7l-.2.3-4-2.2-4 2.2"/></svg></span>';});

